import { Outlet } from 'react-router-dom';

import Intro from '@/assets/videos/intro.mp4';

import * as style from './styles';

export function LoginLayout() {
  return (
    <div className={style.container()}>
      <section className={style.banner()}>
        <video className={style.bannerImage()} loop autoPlay muted>
          <source src={Intro} type="video/mp4" />
        </video>
      </section>

      <Outlet />
    </div>
  );
}
